import React, { useState } from 'react';
import Input from "@mui/material/Input";
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import {ICommentDialogProps} from "./~types/CommentDialogProps"
import './CommentDialog.css';
import { useTranslation } from 'react-i18next';

const CommentDialog = (props: ICommentDialogProps) => {
    const { t } = useTranslation();

    const [isCommentDialogOpen, setIsCommentDialogOpen] = useState(false);
    const [messageText, setMessageText] = useState("");

    const _setCommentMenuHeight = () => {
        setTimeout(() => {
            let textareaHeight = document.getElementById("comment__textarea")?.offsetHeight;
            let nameLabelHeight = document.getElementById("comment-container__name")?.offsetHeight;
            const dropdownHeight = (textareaHeight ?? 0) + (nameLabelHeight ?? 0);
            document.getElementById('comment-dialog_window')?.style.setProperty('height', dropdownHeight != 0 ? `${dropdownHeight + 40}px` : '');
        });
    }

    const _onCommentTextChanged = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        _setCommentMenuHeight();
        setMessageText(event.target.value);
    }

    const _onSendComment = () => {
        props.onCommentSend(props.chatId, messageText);
        setMessageText("")
        setIsCommentDialogOpen(false);
    }

    const handleToggleMenu = () => {
        setIsCommentDialogOpen(!isCommentDialogOpen);
        _setCommentMenuHeight();
    }

    return (
      <Dropdown
        isOpen={isCommentDialogOpen}
        toggle={handleToggleMenu}
        direction="up"
      >
        <DropdownToggle className="comment-dialog__toggle">
          {t("chat.comment")}
        </DropdownToggle>
        {isCommentDialogOpen && (
          <DropdownMenu
            className="comment-dialog_window"
            id="comment-dialog_window"
          >
            <div
              className="comment-container__name"
              id="comment-container__name"
            >
              {t("chat.comment")}
            </div>
            <span className="comment-dialog_text-area">
              <Input
                id="comment__textarea"
                type="text"
                className="comment-editor__input"
                value={messageText}
                multiline={true}
                maxRows={10}
                autoFocus
                onChange={(event) => _onCommentTextChanged(event)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" && !event.shiftKey) {
                    props.onCommentSend(props.chatId, messageText);
                    setMessageText("");
                    setIsCommentDialogOpen(false);
                  }
                }}
              />
            </span>
            <i
              className="send-comment__button material-icons"
              onClick={_onSendComment}
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                    _onSendComment();
                }
              }}
            >
              send
            </i>
          </DropdownMenu>
        )}
      </Dropdown>
    );
}

export default CommentDialog;